import CheckboxComponent from '../../../components/CheckboxComponent';
import ButtonComponent from '../../../components/ButtonComponent';
import { Grid2 } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import zod from 'zod';
import { DeviceRecoverEventConfigFormSchema } from '../../../services/Devices/schemas';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  useGetRecoverEventConfigAsync,
  useUpdateRecoverEventConfigAsync,
} from '../../../services/Devices/hooks/useMutation';
import { AppContext } from '../../../context/AppContextProvider';
import DropdownComponent from '../../../components/DropdownComponent';
import { NumberFieldComponent } from '../../../components/NumberFieldComponent';

interface DeviceRecoverEventConfigProps {
  id: number;
}

type DeviceRecoverEventConfigFormInput = zod.infer<
  typeof DeviceRecoverEventConfigFormSchema
>;

const DeviceRecoverEventConfig = ({ id }: DeviceRecoverEventConfigProps) => {
  const { showSnackbar } = useContext(AppContext);
  const {
    control,
    reset,
    handleSubmit
  } = useForm<DeviceRecoverEventConfigFormInput>({
    resolver: zodResolver(DeviceRecoverEventConfigFormSchema),
    defaultValues: {
      intervalHours: 0,
      isEnable: false,
      recoverEventType: 'COMMON',
    },
  });

  const {
    mutateAsync: mutateGetRecoverEventConfigAsync,
    isLoading: isLoadingGetRecoverEventConfigAsync,
  } = useGetRecoverEventConfigAsync();

  const {
    mutateAsync: mutateUpdateRecoverEventConfigAsync,
    isLoading: isLoadingUpdateRecoverEventConfigAsync,
  } = useUpdateRecoverEventConfigAsync();

  const handleSave = async (data: DeviceRecoverEventConfigFormInput) => {
    mutateUpdateRecoverEventConfigAsync(
      { id, data },
      {
        onSuccess: () => {
          showSnackbar(
            'Configuração de atualização de evento atualizado com sucesso.',
            'success',
          );
        },
      },
    );
  };

  const OPTIONS = [
    { label: 'Entrada de alarme', value: 'ALARM_ENTRY' },
    { label: 'Geração comum de evento', value: 'COMMON' },
  ];

  useEffect(() => {
    if (id)
      mutateGetRecoverEventConfigAsync(id).then((v) =>
        reset(v, { keepDefaultValues: true }),
      );
  }, [id]);

  return (
    <>
      <Grid2 container columnSpacing={2}>
        <Grid2 size={{ xl: 6, xs: 12 }}>
          <Controller
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <DropdownComponent
                label={'Tipo de recuperação'}
                value={value}
                optionLabel={'label'}
                optionValue={'value'}
                options={OPTIONS}
                onChange={onChange}
              />
            )}
            name={'recoverEventType'}
            control={control}
          />
        </Grid2>
        <Grid2 size={{ xl: 6, xs: 12 }}>
          <Controller
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <NumberFieldComponent
                label={'Intervalo de recuperação (em horas)'}
                value={value}
                onValueChange={onChange}
              />
            )}
            name={'intervalHours'}
            control={control}
          />
        </Grid2>
        <Grid2 size={{ xl: 6, xs: 12 }}>
          <Controller
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <CheckboxComponent
                label="Habilitado"
                value={value}
                onChange={onChange}
              />
            )}
            name={'isEnable'}
            control={control}
          />
        </Grid2>
        <Grid2 size={12} sx={{ mt: 1 }}>
          <ButtonComponent
            fullWidth
            onClick={handleSubmit(handleSave)}
            loading={
              isLoadingGetRecoverEventConfigAsync ||
              isLoadingUpdateRecoverEventConfigAsync
            }
          >
            Salvar
          </ButtonComponent>
        </Grid2>
      </Grid2>
    </>
  );
};

export default DeviceRecoverEventConfig;
